import clsx from "clsx";
import * as React from "react";
import * as PropTypes from "../prop-types";
import { PropsType } from "../PropsType";
import { spsGlobalPropTypes } from "../util";
import {SpsButton} from "../button/SpsButton";

export const propTypes = {
    ...spsGlobalPropTypes,
    onClose: PropTypes.fun<() => void>()
};

export type SpsFocusedTaskProps = PropsType<typeof propTypes> & React.HTMLAttributes<HTMLDivElement>;

export function SpsFocusedTask(props: SpsFocusedTaskProps) {
    const {
        children,
        className,
        onClose,
        title,
        "data-testid": testId,
        unsafelyReplaceClassName,
        ...rest
    } = props;

    const classes = clsx(
        unsafelyReplaceClassName || "sps-focused-task",
        "z-stratum-dialog",
        className,
    );

    return (
        <div className={classes} data-testid={testId} {...rest}>
            <div className="sps-focused-task__title">
                <SpsButton className="sps-focused-task__close-btn" kind="icon" icon="x" onClick={onClose}/>
            </div>
            <div className="sps-page">
                {children}
            </div>
        </div>
    );
}
